// extracted by mini-css-extract-plugin
export default {"thumbnail":"thumbnail_thumbnail__MLrOr","thumbnailTitle":"thumbnail_thumbnailTitle__4BOtc"};